import { useEffect } from 'react';

const HiddenField = ({ field, value, onChange }) => {
  useEffect(() => {
    let fieldValue = field.hiddenConfig?.value || '';

    // Se há um parâmetro URL configurado, tentar capturá-lo
    if (field.hiddenConfig?.paramName) {
      const urlParams = new URLSearchParams(window.location.search);
      const paramValue = urlParams.get(field.hiddenConfig.paramName);
      
      if (paramValue) {
        // Se permite sobrescrita ou não há valor atual
        if (field.hiddenConfig.allowOverride || !fieldValue) {
          fieldValue = paramValue;
        }
      }
    }

    // Se há valor atual e não permite sobrescrita, manter o atual
    if (value && !field.hiddenConfig?.allowOverride) {
      fieldValue = value;
    }

    // Só atualizar se o valor mudou
    if (fieldValue !== value) {
      onChange(fieldValue);
    }
  }, [field, value, onChange]);

  // Campo oculto não renderiza nada visualmente
  return null;
};

export default HiddenField;